<div [formGroup]="formGroup" class="pure-g">
  <!-- Mode -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    @if (isEditMode) {
      <mc-input ngDefaultControl label="Mode" formControlName="repairMode" [disabled]="true" fit="small" required> </mc-input>
    } @else {
      <mc-select
        ngDefaultControl
        label="Mode"
        formControlName="repairMode"
        [attr.invalid]="isControlInErrorState(formGroup.controls['repairMode'])"
        fit="small"
        placeholder="Select a mode"
        required
        (optionselected)="onModeChange($event)">
        @for (mode of repairModeList; track mode) {
          <mc-option [value]="mode">{{ mode }}</mc-option>
        }
        @if (formGroup.get('repairMode')?.hasError('required')) {
          <span slot="errormessage">Mode is required</span>
        }
      </mc-select>
    }
  </div>

  <!-- Repair Code -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    @if (isEditMode) {
      <mc-input ngDefaultControl label="Repair Code" formControlName="repairCode" [disabled]="true" fit="small" required> </mc-input>
    } @else {
      <mc-input
        ngDefaultControl
        label="Repair Code"
        formControlName="repairCode"
        placeholder="Enter 4-digit repair code"
        [attr.invalid]="isControlInErrorState(formGroup.controls['repairCode'])"
        fit="small"
        required
        (blur)="onRepairCodeChange($event)"
        (keyup.enter)="onRepairCodeChange($event)">
        @if (formGroup.get('repairCode')?.hasError('required')) {
          <span slot="errormessage">Repair Code is required</span>
        } @else if (formGroup.get('repairCode')?.hasError('pattern')) {
          <span slot="errormessage">Repair Code must be a 4-digit code</span>
        }
      </mc-input>
    }
  </div>

  <!-- Description -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-input ngDefaultControl label="Description" formControlName="description" [disabled]="true" fit="small"></mc-input>
  </div>

</div>
